import { createSlice, PayloadAction } from "@reduxjs/toolkit";

type IUser = {
  id: number | null;
  login_id: string;
  useremail: string;
  username: string;
  phone_num: string;
  birth: string;
  accessToken: string;
};

const initialState = {
  userInfo: {
    id: null,
    login_id: "",
    useremail: "",
    username: "",
    name: "",
    phone_num: "",
    birth: "",
    accessToken: "",
  } as IUser,
};
const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setUserInfo(state, action: PayloadAction<IUser>) {
      state.userInfo = {
        ...action.payload,
      };
    },
    setAccessToken(state, action: PayloadAction<string>) {
      state.userInfo.accessToken = action.payload;
    },
  },
  // extraReducers: (builder) => {},
});

export default userSlice;
